import { Modal, Button } from 'antd';
import PropTypes from 'prop-types';
import styles from '../../styles/modal.module.scss';

const VerifyUserModal = ({
  visible,
  onConfirm,
  onCancel,
  loading,
  userName,
  title = 'Verifikuj korisnika',
  actionText = 'verifikujete',
  confirmLabel = 'Verifikuj',
  loadingLabel = 'Verifikacija...',
}) => (
  <Modal open={visible} footer={null} closeIcon={null} onCancel={onCancel}>
    <div className={styles.modal}>
      <p className={styles.modal__title}>{title}</p>
      <p className={styles.modal__message}>
        Da li ste sigurni da želite da {actionText} korisnika{' '}
        <strong>{userName}</strong>?
      </p>
      <div className={styles.modal__buttons}>
        <Button className="btn-tertiary" onClick={onCancel} disabled={loading}>
          <span>Odustani</span>
        </Button>
        <Button className="btn-primary" onClick={onConfirm} disabled={loading}>
          <span>{loading ? loadingLabel : confirmLabel}</span>
        </Button>
      </div>
    </div>
  </Modal>
);

VerifyUserModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  userName: PropTypes.string,
  title: PropTypes.string,
  actionText: PropTypes.string,
  confirmLabel: PropTypes.string,
  loadingLabel: PropTypes.string,
};

export default VerifyUserModal;
